/**
 * Variant Availability Manager
 * Manages product variant availability states and updates UI accordingly
 */
(function() {
  
  var variantConfig = {
    dataElementId: 'product-variants-data',
    variantDetailId: 'variant-detail-id-title',
    mainDropdownId: 'dropdownMattressSize',
    optionSelectorsClass: '.single-option-selector',
    buttonSelectors: [
      '.product-box product-form button[type="submit"]',
      'product-form button[type="submit"]',
      '.product-buy button[type="submit"]',
      'button[name="add"][type="submit"]'
    ],
    availableClass: 'available',
    soldoutClass: 'soldout',
    disabledClass: 'disabled',
    availableButtonText: 'ADD TO CART <span class="inline-loader"><i class="mdi mdi-loading mdi-spin"></i></span>',
    soldoutButtonText: 'SOLD OUT'
  };
  
  var cachedVariantsData = null;
  var isTemplateCompatible = null;
  
  function checkTemplateCompatibility() {
    if (isTemplateCompatible !== null) return isTemplateCompatible;
    var hasVariantsData = !!document.getElementById(variantConfig.dataElementId);
    var hasVariantDetail = !!document.getElementById(variantConfig.variantDetailId);
    var hasDropdown = !!document.getElementById(variantConfig.mainDropdownId);
    isTemplateCompatible = hasVariantsData && (hasVariantDetail || hasDropdown);
    return isTemplateCompatible;
  }
  
  function getVariantsData() {
    if (cachedVariantsData) return cachedVariantsData;
    var dataElement = document.getElementById(variantConfig.dataElementId);
    if (!dataElement || !dataElement.textContent) return null;
    try {
      cachedVariantsData = JSON.parse(dataElement.textContent);
      return cachedVariantsData;
    } catch(error) {
      return null;
    }
  }
  
  function getCurrentVariantId() {
    var variantDetailEl = document.getElementById(variantConfig.variantDetailId);
    if (variantDetailEl) {
      var variantId = variantDetailEl.getAttribute('current-variant-id');
      if (variantId) return variantId;
    }
    var dropdown = document.getElementById(variantConfig.mainDropdownId);
    if (dropdown && dropdown.value) return dropdown.value;
    if (dropdown) {
      var selectedOption = dropdown.options[dropdown.selectedIndex];
      if (selectedOption && selectedOption.value) return selectedOption.value;
    }
    return null;
  }
  
  function findCurrentVariant(variantId, variants) {
    if (!variants || !variantId) return null;
    return variants.find(function(variant) {
      return variant && variant.id && variant.id.toString() === variantId.toString();
    });
  }
  
  function findAddToCartButton() {
    for (var i = 0; i < variantConfig.buttonSelectors.length; i++) {
      var button = document.querySelector(variantConfig.buttonSelectors[i]);
      if (button) return button;
    }
    return null;
  }
  
  function updateButtonState(button, isAvailable) {
    if (!button) return;
    try {
      if (isAvailable) {
        button.classList.remove(variantConfig.disabledClass);
        button.removeAttribute('disabled');
        button.innerHTML = variantConfig.availableButtonText;
      } else {
        button.classList.add(variantConfig.disabledClass);
        button.setAttribute('disabled', 'disabled');
        button.innerHTML = variantConfig.soldoutButtonText;
      }
    } catch(e) {}
  }
  
  function updateBodyAvailabilityClass(isAvailable) {
    try {
      if (document.body && document.body.classList) {
        document.body.classList.remove(variantConfig.availableClass, variantConfig.soldoutClass);
        document.body.classList.add(isAvailable ? variantConfig.availableClass : variantConfig.soldoutClass);
      }
    } catch(e) {}
  }
  
  function updateVariantAvailability() {
    if (!checkTemplateCompatibility()) return;
    var currentVariantId = getCurrentVariantId();
    var productVariants = getVariantsData();
    if (!productVariants || !currentVariantId) return;
    var selectedVariant = findCurrentVariant(currentVariantId, productVariants);
    if (!selectedVariant) return;
    var isVariantAvailable = Boolean(selectedVariant.available);
    try {
      updateBodyAvailabilityClass(isVariantAvailable);
      updateButtonState(findAddToCartButton(), isVariantAvailable);
    } catch(e) {}
  }
  
  function attachVariantChangeListeners() {
    if (!checkTemplateCompatibility()) return;
    try {
      var mainDropdown = document.getElementById(variantConfig.mainDropdownId);
      if (mainDropdown) {
        mainDropdown.addEventListener('change', updateVariantAvailability);
      }
      var optionSelectors = document.querySelectorAll(variantConfig.optionSelectorsClass);
      if (optionSelectors.length > 0) {
        optionSelectors.forEach(function(selector) {
          selector.addEventListener('change', updateVariantAvailability);
        });
      }
      var variantDetailEl = document.getElementById(variantConfig.variantDetailId);
      if (variantDetailEl) {
        var variantObserver = new MutationObserver(updateVariantAvailability);
        variantObserver.observe(variantDetailEl, {
          attributes: true,
          attributeFilter: ['current-variant-id']
        });
      }
    } catch(e) {}
  }
  
  function initializeVariantUpdater() {
    if (!checkTemplateCompatibility()) return;
    updateVariantAvailability();
    attachVariantChangeListeners();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVariantUpdater);
  } else {
    initializeVariantUpdater();
  }
  
})();